"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var controls_translation_service_1 = require("../../shared/controls-translation.service");
require("./sis-multilingual-copy.component.css");
var copy_language_cache_service_1 = require("../../shared/copy-language-cache.service");
var MultilingualCopy = /** @class */ (function () {
    function MultilingualCopy(translationService, copyCacheService) {
        this.translationService = translationService;
        this.copyCacheService = copyCacheService;
        /**
         * Emits an array of CopyLanguage objects for handling the copying in parent multilingual compoenent.
         * @type {CopyLanguage[]}
         */
        this.onCopyAction = new core_1.EventEmitter();
        /**
         * Displayed columns for the mat table of copy panel.
         * @type {boolean}
         */
        this.displayedColumns = ['nameString', 'checkbox'];
    }
    MultilingualCopy.prototype.ngOnInit = function () {
        var _this = this;
        var copyLangIds = this.copyCacheService.getCachedLanguageIds(this.primaryLanguageId);
        this._copyLanguages = [];
        this.languages.forEach(function (lang) {
            if (lang.getId() !== _this.selectedLanguageId) {
                _this._copyLanguages.push({
                    id: lang.getId(),
                    name: lang.getAcronym(),
                    checked: copyLangIds.indexOf(lang.getId()) > -1,
                });
            }
        });
        this._filteredRows = this._copyLanguages;
        this.resetAllSelected();
    };
    MultilingualCopy.prototype.ngAfterViewInit = function () {
        this.height = this.table.nativeElement.offsetHeight;
    };
    MultilingualCopy.prototype.checkboxAction = function (event, copyLanguage) {
        copyLanguage.checked = event.checked;
        this.resetAllSelected();
    };
    MultilingualCopy.prototype.clearSearch = function () {
        this._searchText = '';
        this.resetFilteredRows();
        this.resetAllSelected();
    };
    MultilingualCopy.prototype.onCopy = function () {
        var selectedLangIds = this._copyLanguages.filter(function (lang) { return lang.checked; }).map(function (lang) { return lang.id; });
        this.copyCacheService.cacheLanguageIds(this.primaryLanguageId, selectedLangIds);
        this.onCopyAction.emit(selectedLangIds);
    };
    Object.defineProperty(MultilingualCopy.prototype, "searchText", {
        get: function () {
            return this._searchText;
        },
        set: function (value) {
            this._searchText = value;
            this.resetFilteredRows();
            this.resetAllSelected();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultilingualCopy.prototype, "filteredRows", {
        get: function () {
            return this._filteredRows;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultilingualCopy.prototype, "selectedLanguages", {
        get: function () {
            return this._copyLanguages.filter(function (copy) { return copy.checked; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultilingualCopy.prototype, "areAllSelected", {
        get: function () {
            return this._areAllSelected;
        },
        set: function (value) {
            this.filteredRows.forEach(function (copy) { return copy.checked = value; });
        },
        enumerable: true,
        configurable: true
    });
    MultilingualCopy.prototype.resetFilteredRows = function () {
        var _this = this;
        if (!this._copyLanguages) {
            this._filteredRows = [];
        }
        if (!this._searchText) {
            this._filteredRows = this._copyLanguages;
        }
        this._filteredRows = this._copyLanguages.filter(function (item) {
            return item.name.getValue(_this.primaryLanguageId).toLocaleLowerCase().includes(_this._searchText.toLowerCase());
        });
    };
    MultilingualCopy.prototype.resetAllSelected = function () {
        this._areAllSelected = this._filteredRows.length > 0 && !this._filteredRows.some(function (copy) { return !copy.checked; });
    };
    MultilingualCopy.prototype.getMessage = function (key, placeholder) {
        return this.translationService && (!placeholder ? this.translationService.getMessage(key) : this.translationService.getMessageWithPlaceholder(key, placeholder));
    };
    MultilingualCopy.prototype.trackByLanguage = function (index, language) {
        return language.id;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MultilingualCopy.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], MultilingualCopy.prototype, "languages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MultilingualCopy.prototype, "primaryLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MultilingualCopy.prototype, "selectedLanguageId", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], MultilingualCopy.prototype, "onCopyAction", void 0);
    __decorate([
        core_1.ViewChild('table'),
        __metadata("design:type", core_1.ElementRef)
    ], MultilingualCopy.prototype, "table", void 0);
    MultilingualCopy = __decorate([
        core_1.Component({
            
            selector: "sis-multilingual-copy",
            template: require('./sis-multilingual-copy.component.html'),
        }),
        __param(0, core_1.Optional()),
        __metadata("design:paramtypes", [controls_translation_service_1.ControlsTranslationService,
            copy_language_cache_service_1.CopyLanguageCacheService])
    ], MultilingualCopy);
    return MultilingualCopy;
}());
exports.MultilingualCopy = MultilingualCopy;
//# sourceMappingURL=sis-multilingual-copy.component.js.map